/*eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { FormattedNumber } from 'react-intl';

import InfiniteCalendar from 'react-infinite-calendar';
import 'react-infinite-calendar/styles.css';
import localePortuguese from 'date-fns/locale/pt';

import LoadMask from '../../../../../../components/LoadMask';
import EmptyState from '../../../../../../components/EmptyState';
import Button from '../../../../../../components/Button';
import SubHeader from '../../../../../../components/SubHeader';
import Modal from '../../../../../../components/Modal';
import SideMenu from '../SideMenu';
import { scheduleTypesToLabel } from '../../../../util/scheduling.js';
import TimeTable from '../TimeTable';

import './styles.css';
import BottomBar from '../../../../components/BottomBar';
import {
  changeStep,
  getAvailableHours,
  selectDate,
  selectSchedules,
  lockSchedule,
  addSchedule,
} from '../../../../../../redux/new-schedule';
import {
  getAvailableHoursUI,
  getAddScheduleUI,
  getScheduleData,
} from '../../../../../../redux/selectors';

class Calendar extends Component {
  constructor() {
    super();
    this.state = {
      scheduleHours: 2,
      confirmModalVisible: false,
    };
  }

  componentDidMount = () => {
    if (this.props.currentStep !== 4) {
      this.props.dispatch(changeStep(this.props.currentStep));
    }
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.props.addScheduleUI.isFetching === true &&
      nextProps.addScheduleUI.isFetching === false
    ) {
      this.props.history.push(
        this.props.match.url.replace(this.props.match.url, '/u/agendamento'),
      );
    }
  }

  _onDismiss = () => {
    this.setState({ confirmModalVisible: !this.state.confirmModalVisible });
  };

  _selectSchedule = schedule => {
    if (!this.props.locked) {
      if (this.props.availableHours.includes(schedule)) {
        let scheduleUp = Array(this.state.scheduleHours).fill(0);
        let scheduleCenter = Array(this.state.scheduleHours).fill(0);
        let scheduleDown = Array(this.state.scheduleHours).fill(0);
        scheduleUp = scheduleUp
          .map((v, i) => schedule - i)
          .reverse()
          .filter(v => this.props.availableHours.includes(v));
        scheduleCenter = scheduleCenter
          .map((v, i, arr) => {
            if (i < arr / 2) {
              return schedule - parseInt(i - arr / 2);
            }
            return schedule + i;
          })
          .filter(v => this.props.availableHours.includes(v));
        scheduleDown = scheduleDown
          .map((v, i) => schedule + i)
          .filter(v => this.props.availableHours.includes(v));
        if (scheduleUp.length !== this.state.scheduleHours) {
          scheduleUp = undefined;
        }
        if (scheduleCenter.length !== this.state.scheduleHours) {
          scheduleCenter = undefined;
        }
        if (scheduleDown.length !== this.state.scheduleHours) {
          scheduleDown = undefined;
        }

        if (scheduleCenter) {
          this.props.dispatch(selectSchedules(scheduleCenter));
        } else if (scheduleDown) {
          this.props.dispatch(selectSchedules(scheduleDown));
        } else if (scheduleUp) {
          this.props.dispatch(selectSchedules(scheduleUp));
        }
      } else {
        this.props.dispatch(selectSchedules([]));
      }
    }
  };

  _selectDate = date => {
    this.props.dispatch(selectDate(date));
    this.props.dispatch(getAvailableHours(moment(date).format('YYYY-MM-DD')));
  };

  _openModal = () => {
    this.setState({ confirmModalVisible: !this.state.confirmModalVisible });
  };

  _addSchedule = () => {
    const { scheduleData, dispatch } = this.props;
    dispatch(addSchedule(scheduleData));
  };

  _calcScreen = () => {
    if (window.innerWidth < 600) {
      return window.innerWidth - 50;
    }
    return window.innerWidth / 2 - 50;
  };

  render() {
    const locale = {
      blank: 'Selecione uma data...',
      headerFormat: 'dddd, DD MMM YYYY',
      todayLabel: {
        long: 'Hoje',
      },
      weekdays: ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB'],
      weekStartsOn: 0,
      locale: localePortuguese,
    };

    const {
      match,
      history,
      selectedDay,
      selectedSchedules,
      scheduleData,
      availableHoursUI,
      addScheduleUI,
    } = this.props;

    return (
      <div className="Calendar">
        <SubHeader
          title="Agendar"
          renderSide={() => <SideMenu match={match} history={history} />}
        />
        <div className="Calendar__wrapper">
          <div className="Calendar__choice Calendar__choice--left">
            <span className="Calendar__title">Selecione a data</span>
            <InfiniteCalendar
              minDate={new Date()}
              min={moment().subtract(1, 'w').toDate()}
              max={moment().add(6, 'M').toDate()}
              selected={selectedDay}
              onSelect={this._selectDate}
              width={this._calcScreen()}
              height={300}
              rowHeight={60}
              locale={locale}
              theme={{
                selectionColor: 'var(--luft-primary)',
                textColor: {
                  default: '#333',
                  active: '#FFF',
                },
                weekdayColor: 'var(--luft-primary)',
                headerColor: 'var(--luft-secondary)',
                floatingNav: {
                  background: 'var(--luft-secondary)',
                  color: '#FFF',
                  chevron: '#FFF',
                },
              }}
            />
          </div>
          {selectedDay ? (
            <div className="Calendar__choice">
              <span className="Calendar__title">Selecione o horário</span>
              <TimeTable
                availableHours={this.props.availableHours}
                scheduleHours={this.state.scheduleHours}
                selectedSchedules={selectedSchedules}
                selectSchedule={this._selectSchedule}
                lockSchedule={() => {
                  this.props.dispatch(lockSchedule(!this.props.locked));
                }}
                isLocked={this.props.locked}
                weekDay={moment(selectedDay).format('dddd')}
              />
            </div>
          ) : (
            <EmptyState
              message="Selecione uma data"
              className="Calendar__empty-choice"
            />
          )}
        </div>
        {this.props.locked && (
          <BottomBar>
            <div className="Calendar__bottom-bar">
              <div className="Calendar__bottom-bar-wrapper">
                <div className="Calendar__bottom-bar-date">
                  {moment(selectedDay).format('DD/MM/YYYY')}
                </div>
                <div>
                  {moment(selectedDay).format('dddd, DD [de] MMMM [de] YYYY')} -{' '}
                  <b>
                    {`Das ${selectedSchedules[0]}h às ${
                      selectedSchedules[selectedSchedules.length - 1] + 1
                    }h (Duração: ${selectedSchedules.length}h)`}
                  </b>
                </div>
              </div>
              <Button
                className="Calendar__confirm-button"
                skin="secondary"
                text="Confirmar agendamento"
                onClick={this._openModal}
              />
            </div>
          </BottomBar>
        )}

        {this.state.confirmModalVisible && (
          <Modal
            title="Confirmar agendamento"
            size="small"
            onBackdropClick={this._onDismiss}
          >
            <div className="Modal__withou-padding-content">
              <div className="Modal__dual-field">
                <div className="Modal__field Modal__field--first Modal__wrapper">
                  <div className="Modal__field-header">1. Tipo</div>
                  <div className="Modal__field-content">
                    {scheduleTypesToLabel[scheduleData.scheduling.type]}
                  </div>
                </div>
                {/* <div className="Modal__field">
                  2. Embarcador
                </div> */}
              </div>
              <div className="Modal__line Modal__wrapper">
                <div className="Modal__field-header">Notas fiscais</div>
                <div className="Modal__field-content">
                  {scheduleData.nfList.reduce(
                    (acc, cv, index, arr) =>
                      index === arr.length - 1
                        ? acc.concat(`${cv.nf}-${cv.nfGroup}`)
                        : acc.concat(`${cv.nf}-${cv.nfGroup} ,`),
                    [],
                  )}
                </div>
              </div>
              <div className="Modal__dual-field">
                <div className="Modal__field Modal__field--first Modal__wrapper">
                  <div className="Modal__field-header">Peso Total</div>
                  <div className="Modal__field-content">
                    <FormattedNumber
                      // -disable-next-line react/style-prop-object
                      style="currency"
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                      value={scheduleData.nfList.reduce(
                        (acc, cv) => (acc += cv.weight),
                        0,
                      )}
                      useGrouping
                    />{' '}
                    kg
                  </div>
                </div>
                <div className="Modal__field Modal__wrapper">
                  <div className="Modal__field-header">Valor Total</div>
                  <div className="Modal__field-content">
                    <FormattedNumber
                      // -disable-next-line react/style-prop-object
                      style="currency"
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                      currency="BRL"
                      currencyDisplay="symbol"
                      value={scheduleData.nfList.reduce(
                        (acc, cv) => (acc += cv.value),
                        0,
                      )}
                      useGrouping
                    />
                  </div>
                </div>
              </div>
              <div className="Modal__line Modal__wrapper">
                <div className="Modal__field-header">Data, horário e local</div>
                <div className="Modal__field-content">
                  {moment(selectedDay).format('dddd, DD [de] MMMM [de] YYYY')},{' '}
                  {`às ${selectedSchedules[0]}h`}
                </div>
              </div>
              <div className="Modal__dual-field">
                <div className="Modal__field Modal__field--first Modal__wrapper">
                  <div className="Modal__field-header">Motorista</div>
                  <div className="Modal__field-content">
                    {this.props.selectedDriver.name}
                  </div>
                </div>
                <div className="Modal__field Modal__wrapper">
                  <div className="Modal__field-header">Veículo</div>
                  <div className="Modal__field-content">
                    {this.props.selectedVehicle.name}
                  </div>
                </div>
              </div>

              <div className="Modal__footer">
                <Button
                  className="Modal__button"
                  type="button"
                  text="Confirmar"
                  skin="primary"
                  onClick={this._addSchedule}
                />
                <Button
                  className="Modal__button"
                  type="button"
                  text="Cancelar"
                  skin="gray-light"
                  onClick={this._onDismiss}
                />
              </div>
            </div>
            {addScheduleUI.isFetching && <LoadMask text="Salvando..." />}
          </Modal>
        )}

        {availableHoursUI.isFetching && <LoadMask text="Carregando..." />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentStep: state.newSchedule.currentStep,
  availableStep: state.newSchedule.availableStep,
  availableDates: state.newSchedule.availableDates.list,
  availableHours: state.newSchedule.availableHours.list,
  currentType: state.newSchedule.currentType,
  selectedSchedules: state.newSchedule.selectedSchedules,
  locked: state.newSchedule.lockScheduleStatus,
  selectedDay: state.newSchedule.selectedDay,
  nfList:
    state.newSchedule.currentType === 0
      ? state.newSchedule.loadSchedule.nfSelectedsList
      : state.newSchedule.unloadSchedule.nfList,
  selectedDriver:
    state.newSchedule.currentType === 0
      ? state.newSchedule.loadSchedule.selectedDriver
      : state.newSchedule.unloadSchedule.selectedDriver,
  selectedVehicle:
    state.newSchedule.currentType === 0
      ? state.newSchedule.loadSchedule.selectedVehicle
      : state.newSchedule.unloadSchedule.selectedVehicle,
  availableHoursUI: getAvailableHoursUI(state),
  addScheduleUI: getAddScheduleUI(state),
  scheduleData: getScheduleData(state),
});

export default connect(mapStateToProps)(Calendar);
